import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// PAGES
import LoginPage from "../pages/login/LoginPage";
import LoginOfflinePage from "../pages/loginOffline/LoginOfflinePage";
// import NotFoundPage from "../pages/unauthorized/NotFoundPage";
import MssaPage from "../pages/termsAndConditions/MssaPage";
import EulaPage from "../pages/termsAndConditions/EulaPage";
import SlaPage from "../pages/termsAndConditions/SlaPage";
import SupportPolicy from "../pages/termsAndConditions/SupportPolicy";
import DualCompatDemoPage from "../pages/dualCompatDemo/DualCompatDemoPage";

export default function PublicRouter() {
  const isOffline = process.env.REACT_APP_ENVIRONMENT === "OFFLINE";

  return (
    <Routes>
      <Route
        path="/login"
        element={isOffline ? <Navigate to="/login-offline" replace /> : <LoginPage />}
      />
      <Route
        path="/login-offline"
        element={isOffline ? <LoginOfflinePage /> : <Navigate to="/login" replace />}
      />

      <Route path="/terms/mssa" element={<MssaPage />} />
      <Route path="/terms/eula" element={<EulaPage />} />
      <Route path="/terms/sla" element={<SlaPage />} />
      <Route path="/terms/supportpolicy" element={<SupportPolicy />} />

      {/* Dual-schema decode visual confirmation (no auth) */}
      <Route path="/dual-compat-demo" element={<DualCompatDemoPage />} />

      {/* Public 404 */}
      <Route path="*" element={<Navigate to={isOffline ? "/login-offline" : "/login"} replace />} />
    </Routes>
  );
}
